import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import WhoisModal from './whois-modal';
import { fetchWhois } from '../common/actions/whois-action-creators';
import { closeModal } from '../common/actions/modal-action-creators';
import { whoisIsLoadingSelector } from '../common/selectors/whois-selectors';
import { whoisDataForDomainModalSelector, whoisModalDomainSelector } from './whois-modal-selectors';

export class WhoisModalContainer extends React.Component{
    componentDidMount(){
        this.props.fetchWhois( this.props.domain );
    }

    render(){
        const {
            domain,
            open,
            closeModal,
            whoisData,
            isLoading
        } = this.props;

        return (
            <WhoisModal
                dataAutomationId="whois-modal"
                open={ open }
                onClose={ closeModal }
                isLoading={ isLoading }
                subtitle={ domain }
                whoisData={ whoisData }
            />
        );
    }

};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        domain: whoisModalDomainSelector( state ),
        isLoading: whoisIsLoadingSelector( state ),
        whoisData: whoisDataForDomainModalSelector( state ),
    };
};

WhoisModalContainer.propTypes = {
    closeModal: PropTypes.func.isRequired,
    domain: PropTypes.string.isRequired,
    fetchWhois: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    open: PropTypes.bool.isRequired,
    whoisData: PropTypes.string.isRequired,
};

export default connect( mapStateToProps, { closeModal, fetchWhois } )( WhoisModalContainer );
